"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _clearfix = require("../../styles/clearfix");

var _styledTools = require("styled-tools");

var _responsive = require("../../styles/responsive");

var _breakpoints = require("../../styles/breakpoints");

var _grid = require("../../styles/grid");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      max-width: ", "", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Generated container breakpoints.
 */
var setContainerBreakpoints = function setContainerBreakpoints(_ref) {
  var theme = _ref.theme;
  var _theme$grid = theme.grid,
      containers = _theme$grid.containers,
      unit = _theme$grid.unit;
  return (0, _breakpoints.orderByBreakpoints)(containers, theme.breakpoints).map(function (key) {
    return _responsive.media.min(key)(_templateObject(), containers[key], unit);
  });
};
/**
 * Set container padding.
 */


var setContainerPadding = function setContainerPadding(_ref2) {
  var theme = _ref2.theme;
  var _theme$grid2 = theme.grid,
      gutter = _theme$grid2.gutter,
      unit = _theme$grid2.unit;
  return (0, _styledComponents.css)(["padding-left:", "", ";padding-right:", "", ";"], gutter, unit, gutter, unit);
};
/**
 * `Container` component.
 */


var Container = _styledComponents.default.div.withConfig({
  displayName: "container__Container",
  componentId: "sc-2bwmo-0"
})(["", " margin-left:auto;margin-right:auto;position:relative;width:100%;", " ", " ", ""], _clearfix.clearfix, setContainerPadding, (0, _styledTools.ifProp)('fluid', '', setContainerBreakpoints), _grid.setDebugStyle);
/**
 * Export `Container` component.
 */


var _default = Container;
exports.default = _default;